import React, {FC, memo} from "react";
import styles from "./Footer.module.scss";
import {CustomLink, Image} from "../../common";
import {Container} from "../index";
import {RouteDictionary} from "../../../utils";
import LogoImage, {LogoType} from "../../common/images/types/LogoImage";
import mail from 'assets/images/svg/mail.svg';
import telephone from 'assets/images/svg/telephone.svg';
import clock from 'assets/images/svg/clock.svg';
import cone from 'assets/images/svg/cone-outline.svg';
import apiClientConfig from "../../../configs/app";

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.logoColumn}>
            <LogoImage type={LogoType.FULL} className={styles.logo} />

            <nav className={styles.nav}>
              <CustomLink className={styles.navLink} to={RouteDictionary.ABOUT_US}>
                Раскрытие информации
              </CustomLink>
              {/*<CustomLink className={styles.navLink} to={RouteDictionary.FAQ}>*/}
              {/*  FAQ*/}
              {/*</CustomLink>*/}
              <a
                className={styles.navLink}
                href="https://cdn.conomica-finance.ru/file/31706/7e3/1262-77410/pravila-investicionnoi-platformy-konomika-zaimy-dlya-biznesa2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Правила платформы
              </a>
            </nav>
          </div>
          <nav className={styles.mobileNav}>
            <CustomLink className={styles.navLink} to={RouteDictionary.ABOUT_US}>
              Раскрытие информации
            </CustomLink>
            {/*<CustomLink className={styles.navLink} to={RouteDictionary.FAQ}>*/}
            {/*  FAQ*/}
            {/*</CustomLink>*/}
            <a
              className={styles.navLink}
              href="https://cdn.conomica-finance.ru/file/31706/7e3/1262-77410/pravila-investicionnoi-platformy-konomika-zaimy-dlya-biznesa2.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Правила платформы
            </a>
          </nav>

          <div className={styles.infoColumn}>
            <div className={styles.infoColumnContainer}>
              <div className={styles.infoLabels}>
                <span className={styles.infoLabel}>Оператор платформы</span>
                <span className={styles.infoLabel}>ИНН</span>
                <span className={styles.infoLabel}>Юридический адрес</span>
              </div>
              <div className={styles.infoValues}>
                <span className={styles.infoValue}>ООО &quot;Кономика-займы для бизнеса&quot;</span>
                <span className={styles.infoValue}>9728131284</span>
                <span className={styles.infoValue}>
                  117342, г. Москва,
                  <br />
                  вн.тер.г. муниципальный округ Коньково,
                  <br />
                  ул. Бутлерова, д. 17, помещ. 26/2
                </span>
              </div>
            </div>

            <div className={styles.infoRowMobile}>
              <span className={styles.infoLabelMobile}>Оператор платформы</span>
              <span className={styles.infoValueMobile}>ООО &quot;Кономика-займы для бизнеса&quot;</span>
            </div>
            <div className={styles.infoRowMobile}>
              <span className={styles.infoLabelMobile}>ИНН</span>
              <span className={styles.infoValueMobile}>9728131284</span>
            </div>
            <div className={styles.infoRowMobile}>
              <span className={styles.infoLabelMobile}>Юридический адрес</span>
              <span className={styles.infoValueMobile}>
                117342, г. Москва, вн.тер.г. муниципальный округ Коньково, ул. Бутлерова, д. 17, помещ. 26/2
              </span>
            </div>

            <div className={styles.registryNotice}>
              <a
                className={styles.registryLink}
                href="https://cbr.ru/finorg/foinfo/?ogrn=1247700302618"
                target="_blank"
                rel="noopener noreferrer"
              >
                Оператор платформы состоит в Реестре Инвестиционных платформ ЦБ РФ
              </a>
            </div>
          </div>

          <Image src={cone} alt='' className={styles.cone}/>

          <div className={styles.supportColumn}>
            <div className={styles.supportContent}>
              <span className={styles.supportTitle}>Служба поддержки</span>
              <div className={styles.contactItem}>
                <Image src={telephone} alt={'telephone'} className={styles.contactIcon}/>
                <a href="tel:+74951501667" className={styles.contactLink}>
                  +7 (495) 150-16-67
                </a>
              </div>

              <div className={styles.contactItem}>
                <Image src={mail} alt={'mail'} className={styles.contactIcon}/>
                <a href="mailto:" className={styles.contactLink}>
                  {apiClientConfig.email}
                </a>
              </div>

              <div className={styles.contactItem}>
                <Image src={clock} alt={'clock'} className={styles.contactIcon}/>
                <span className={styles.contactText}>с 9:00 до 19:00</span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default memo(Footer);
